/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import { Modal, message, Button, Table, Input } from 'antd';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import { DataService } from '../../../config/dataService/dataService';
// import { TableWrapper } from '../../styled';
import { TableWrapper } from '../../../container/styled';
import { FORM_HIDE_TIMEOUT_SECONDS, SOCKET_ACTIONS } from '../../../config/config';

const FormDialog = ({ showDialog, isEdit = false, setReload, editId }) => {
  const [busy, setBusy] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]); // State to store selected rows
  const [search, setSearch] = useState('');

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/t-courses/query', { search });
      const { data } = response.data;
      // const tempData = [].concat(data).concat(data).concat(data).concat(data).concat(data)
      setTableData(data);
      // setTableData(tempData);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchTableData(editId);
    }
  }, [isEdit, editId, search]);

  const TableColumns = [
    {
      title: 'Course Name',
      dataIndex: 'title',
      key: 'title',
      field: 'title',
      export: true,
    },
    {
      title: () => {
        return (
          <div className='flex'>
            Center Name
          </div>
        )
      },
      dataIndex: 'center_name',
      key: 'center_name',
      field: 'center_name',
      export: true,
    },
  ];

  // Row selection configuration
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRowsData) => {
      setSelectedRows(selectedRowsData); // Update state with selected rows
    },
    getCheckboxProps: (record) => ({
      disabled: record.disabled, // Example for disabling rows
      name: record.title,
    }),
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleSubmit = async () => {
    try {
      if (selectedRows.length === 0) return message.warning('Please select at least one course!');
      try {
        setBusy(true)
        const courseIDs = [];
        selectedRows.map(item => courseIDs.push({ course_id: item.id, center_id: item.training_center_id }))

        const response = await DataService.post('/emp-training/request', {
          emp_id: editId,
          cource_ids: JSON.stringify(courseIDs)
        });
        const { status } = response.data;
        if (status) {
          message.success(response.data.message, FORM_HIDE_TIMEOUT_SECONDS, () => {
            showDialog(false);
            setReload(true);
          });
        } else {
          setBusy(false)
          message.error(response.data.message)
        }
      } catch (error) {
        message.error(`Error :  ${error.message}`)
        setBusy(false)
      }
    } catch (error) {
      message.error(error.message)
    }
  }

  return (
    <Modal
      open
      title='Select Courses To Send Request'
      okText={isEdit ? 'Update' : 'Create'}
      cancelText="Cancel"
      width="70%"

      // onCancel={() => showDialog(false)}
      // onOk={() => form.submit()}
      centered
      footer={[
        <Button key="cancel" loading={busy} onClick={() => showDialog(false)} disabled={busy}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={busy} onClick={handleSubmit} disabled={busy}>
          Send Request
        </Button>,
      ]}
      cancelButtonProps={{ disabled: busy }}
      destroyOnClose
    >

      <div className="ninjadasj-datatable mh-[50%]"
        style={{ minHeight: 'calc(100vh - 300px)' }}
      >

        <Input
          className=" hover:drop-shadow-xl mb-2 hover:border-solid hover:border-1 hover:border-blue-800 rounded-sm w-1/4"
          size='small'
          autoFocus
          placeholder="Search Anything"
          prefix={<UilSearch size={15} />}
          defaultValue={search}
          onChange={(e) => handleSearch(e.target.value)}
        />

        <TableWrapper>
          <Table
            rowKey={(record) => `${record.id}`} // Generate a unique key for each row
            loading={busy}
            bordered
            virutal
            size='middle'
            className='border rounded drop-shadow-sm'
            pagination={false}
            // rowSelection='multiple'
            dataSource={tableData}
            columns={TableColumns}
            scroll={{ y: 'calc(100vh - 300px)' }} // Adjust height based on dialog size
            rowSelection={{
              type: 'checkbox', // or 'radio'
              ...rowSelection,
            }}
          />
        </TableWrapper>
      </div>

    </Modal>
  );
};

export default FormDialog;
